import React from 'react'
import { ModalProps, useModal } from '../modal'
import Modal from '../modal'
import ServiceForm, { ServiceFormProps } from './service-form'
import { Box, Button, Element } from 'react-bulma-components'
import ConfirmationModal from '../confirmation-modal/confirmation-modal'
import { useUpdateMutation } from '../../queries/services'

interface ServiceModalFormProps extends ServiceFormProps {
  isDisplayed: ModalProps['actions']['isDisplayed']
  setIsDisplayed: ModalProps['actions']['setIsDisplayed']
}

const ServiceModalForm: React.FC<ServiceModalFormProps> = ({
  isDisplayed,
  setIsDisplayed,
  service,
}) => {
  const updateMutation = useUpdateMutation()
  const { isDisplayed: isConfirmationDisplayed, setIsDisplayed: setIsConfirmationDisplayed } =
    useModal()

  const isServiceInactive = service?.isInactive

  const handleToggleStatus = async () => {
    if (!service?._id) return
    await updateMutation.mutateAsync({ id: service._id, isInactive: !isServiceInactive })
    setIsDisplayed(false)
    setIsConfirmationDisplayed(false)
  }

  return (
    <>
      <Modal
        actions={{ isDisplayed, setIsDisplayed }}
        title={service ? "Modifier l'Affectation" : 'Créer une nouvelle Affectation'}
        dataTest="service-modal"
      >
        <Box>
          <ServiceForm service={service} />
        </Box>
        {service && (
          <Box pt={2}>
            <Element
              className="is-flex is-justify-content-space-between is-align-items-center"
              mt={2}
            >
              <Element>
                <Element textWeight="bold">
                  {isServiceInactive
                    ? 'Réactiver cette affectation'
                    : 'Désactiver cette affectation'}
                </Element>
                <Element textSize={7} textColor="grey">
                  {isServiceInactive
                    ? "Une fois réactivé, l'affectation sera à nouveau disponible pour les missions et les demandes"
                    : 'Une fois désactivé, vous pourrez la réactiver plus tard'}
                </Element>
              </Element>
              <Button
                color={isServiceInactive ? 'success' : 'danger'}
                onClick={() => setIsConfirmationDisplayed(true)}
                data-test="disable-service-button"
                size="small"
              >
                {isServiceInactive ? "Réactiver l'affectation" : "Désactiver l'affectation"}
              </Button>
            </Element>
          </Box>
        )}
      </Modal>

      <ConfirmationModal
        show={isConfirmationDisplayed}
        onConfirm={handleToggleStatus}
        onCancel={() => setIsConfirmationDisplayed(false)}
        title={isServiceInactive ? "Réactiver l'affectation" : "Désactiver l'affectation"}
        confirmButtonLabel={isServiceInactive ? 'Réactiver' : 'Désactiver'}
        confirmButtonProps={{
          color: isServiceInactive ? 'success' : 'danger',
          disabled: false,
        }}
      >
        <>
          {isServiceInactive ? (
            <>
              Êtes-vous sûr de vouloir réactiver cette affectation ?
              <br />
              L'affectation sera à nouveau disponible pour les missions et les demandes.
            </>
          ) : (
            <>
              Êtes-vous sûr de vouloir désactiver cette affectation ?
              <br />
              Les missions utilisant cette affectation ne seront pas impactées et conserveront leur
              historique.
              <br />
              <br />
              <Element textWeight="bold">
                L'affectation ne sera plus visible dans les filtres et ne pourra plus être
                sélectionnée pour la création de nouvelles missions et de nouvelles demandes.
              </Element>
            </>
          )}
        </>
      </ConfirmationModal>
    </>
  )
}

export default ServiceModalForm
